const priceFormatter = number => {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return formatter.format(number);
};

const validatePassword = password => {
  return /^(?=.*\d)(?=.*[a-zA-Z]).{8,100}$/.test(password);
};

const validateEmail = email => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

const isRestaurantUser = user => {
  let restaurantOrganizations = user?.employees?.filter(
    employee => employee?.attributes?.organization_type === 'Restaurant'
  );
  return restaurantOrganizations?.length > 0;
};

const formatInputPhoneNumber = (value, { isDeleting }) => {
  if (!value) return '';

  if (isDeleting && (value == '+' || value == '+1' || value == '+1 ')) return value;

  if (value == '+' || value == '+1' || value == '+1 ') return value;

  const hasPlusOne = value.startsWith('+1');

  let digits = value.startsWith('+1')
    ? value.slice(2)
    : value.startsWith('+')
    ? value.slice(1)
    : value;

  digits = digits.replace(/\D/g, '').slice(0, 10);

  if (digits.length < 4) return hasPlusOne ? `+1 ${digits}` : digits;
  if (digits.length < 7)
    return hasPlusOne
      ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3)}`
      : `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return hasPlusOne
    ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    : `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const isValidPhoneNumber = phone => {
  if (!phone) return false;

  // Remove all non-digit characters
  let digits = phone.replace(/\D/g, '');

  // If starts with '1' and length > 10, strip the leading 1 (country code)
  if (digits.startsWith('1') && digits.length > 10) {
    digits = digits.slice(1);
  }

  // Validate: exactly 10 digits
  return digits.length == 10;
};

export default {
  priceFormatter,
  validatePassword,
  validateEmail,
  isRestaurantUser,
  formatInputPhoneNumber,
  isValidPhoneNumber,
};
